import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => ({
  title: {
    fontFamily: 'Roboto-Bold',
    fontSize: 16,
  },
  errorContainer: {
    fontFamily: 'Roboto-Bold',
    fontSize: 14
  },
}));
